import React from "react";

const Footer = () => {
    return (
        < footer className="footer position-relative" >
            < div className="content-overlay position-absolute top-50 start-50 translate-middle text-center text-black" >
                <img
                    src="./logo_makrosoft.png"
                    alt="Logo Makrosoft"
                    width="150"
                    height="50"
                    className="mb-3"
                />
                <div className="fs-6">
                    Proveedor tecnológico{" "}
                    <img
                        src="./logo_makrosoft.png"
                        alt="Logo Makrosoft"
                        width="90"
                        height="20"
                        className="align-middle"
                    />{" "}
                    Software{" "}
                    <img
                        src="./logo_edocx.png"
                        alt="Logo eDocx"
                        width="60"
                        height="20"
                        className="align-middle"
                    />
                </div>
            </div >

            {/* Fondo de ondas */}
            < div className="position-absolute bottom-0 start-0 w-100" >
                <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    width="100%"
                    height="100%"
                    viewBox="0 0 1600 550"
                >
                    <defs>
                        <linearGradient id="bg" x2="0%" y2="100%">
                            <stop offset="0%" style={{ stopColor: "rgb(207, 56, 61,  88%)" }} />
                            <stop
                                offset="100%"
                                style={{ stopColor: "rgba(38, 89, 190, 0.06)" }}
                            />
                        </linearGradient>
                        <path
                            id="wave"
                            fill="url(#bg)"
                            d="M-363.852,502.589c0,0,236.988-41.997,505.475,0
          s371.981,38.998,575.971,0s293.985-39.278,505.474,5.859s493.475,48.368,716.963-4.995v560.106H-363.852V502.589z"
                        />
                    </defs>
                    <g>
                        <use xlinkHref="#wave" opacity=".3" transform="translate(0, 0)" />
                        <use xlinkHref="#wave" opacity=".6" transform="translate(-50, 10)" />
                        <use xlinkHref="#wave" opacity=".9" transform="translate(150, -10)" />
                    </g>
                </svg>
            </div >
        </footer >

    )
};

export default Footer;